export function setCookie(n, v, h) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie =
    n +
    "=" +
    encodeURIComponent(v) +
    "; max-age=" +
    h * 3600 +
    "; path=/; SameSite=Strict" +
    secure;
}
export function getCookie(n) {
  const m = document.cookie.match("(^| )" + n + "=([^;]+)");
  return m ? decodeURIComponent(m[2]) : null;
}
export function eraseCookie(name) {
  document.cookie = name + "=; Max-Age=0; path=/; SameSite=Strict";
}
/** Best human-readable message from an axios error. */
export function apiErrorMessage(err, fallback = "Something went wrong") {
  return err?.response?.data?.msg || fallback;
}

/**
 * Parse a server "YYYY-MM-DD HH:MM[:SS]" timestamp (stored in IST, no zone)
 * as a wall-clock Date. Returns null for empty/invalid input.
 */
export function parseServerDate(value) {
  if (!value) return null;
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);
  if (!m) return null;
  const [, y, mo, d, h, mi, s = "0"] = m;
  const date = new Date(+y, +mo - 1, +d, +h, +mi, +s);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * "Now" as an IST wall-clock Date, comparable with parseServerDate() output
 * whatever time zone the browser is in.
 */
export function serverNow() {
  return new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
}

const dateTimeFmt = new Intl.DateTimeFormat("en-IN", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

/** "31 Oct 2026, 05:30 pm" — or the fallback when the value is unparseable. */
export function formatServerDate(value, fallback = "—") {
  const date = parseServerDate(value);
  return date ? dateTimeFmt.format(date) : fallback;
}

/**
 * Human relative time between two server timestamps, e.g. "5 min ago",
 * "in 2 h". Both values are compared on the same (server) clock so the
 * browser's own time zone never skews the result.
 */
export function relativeTime(value, now) {
  const a = parseServerDate(value);
  const b = parseServerDate(now) || new Date();
  if (!a) return "";
  const diffMin = Math.round((a - b) / 60000);
  const abs = Math.abs(diffMin);
  let text;
  if (abs < 1) return "just now";
  if (abs < 60) text = `${abs} min`;
  else if (abs < 60 * 24) text = `${Math.round(abs / 60)} h`;
  else text = `${Math.round(abs / 1440)} d`;
  return diffMin < 0 ? `${text} ago` : `in ${text}`;
}
